
import { defineComponent, PropType } from 'vue'
import { IssueDistribution } from '~/types/types'
import { IssueDistributionT } from '~/types/reportTypes'

export default defineComponent({
  name: 'DistributionStats',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loaderCount: {
      type: Number,
      default: 6
    },
    linkCards: {
      type: Boolean,
      default: false
    },
    stats: {
      type: Array as PropType<IssueDistribution[]>,
      required: true
    },
    statType: {
      type: String as PropType<IssueDistributionT>,
      default: IssueDistributionT.CATEGORY
    }
  }
})
